import { render, staticRenderFns } from "./RespondentsSubPage.vue?vue&type=template&id=363cce64&"
import script from "./RespondentsSubPage.vue?vue&type=script&lang=ts&"
export * from "./RespondentsSubPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports